/**
 * What the proposal cards need from the pane: the user's token, the bid the
 * pane is linked to, a way to tell the user something, and a hook to run
 * after a proposal is applied (the Tender tab re-reads its questions so a
 * changed limit or status shows at once).
 */
import { type ReactNode, createContext, useContext, useMemo } from "react";

export type ProposalEnv = {
  token: string | null;
  bidId: string | null;
  notify: (message: string) => void;
  onApplied: () => void;
};

const ProposalEnvContext = createContext<ProposalEnv>({
  token: null,
  bidId: null,
  notify: () => undefined,
  onApplied: () => undefined,
});

export const useProposalEnv = (): ProposalEnv => useContext(ProposalEnvContext);

export const ProposalEnvProvider = ({ children, ...env }: ProposalEnv & { children: ReactNode }) => {
  const value = useMemo(() => env, [env.token, env.bidId, env.notify, env.onApplied]);
  return <ProposalEnvContext.Provider value={value}>{children}</ProposalEnvContext.Provider>;
};
